import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useEffect, useMemo, useState } from 'react'
import { ReactComponent as ArrowRight } from '../../../../assets/career/arrow-right.svg'
import GlobalState, {
  changeCareerCoopState,
  changeCoopState,
} from '../../../../stores/GlobalState'
import Pagination from '../../../common/Pagination'
import { VacanciesSearch } from '../Vacancies'

type Vacancy = {
  title: string
  link: string
  location: string
  department: string
  format: string
}

const VacanciesList = observer(({ vacancies }: { vacancies: any }) => {
  const [currentPage, setCurrentPage] = useState(1)

  const [lastPage, setLastPage] = useState(0)
  const [currentItems, setCurrentItems] = useState<Array<Vacancy> | null>(null)
  const [countPerPage, setCount] = useState(6)

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * countPerPage
    const lastPageIndex = firstPageIndex + countPerPage
    return currentItems?.slice(firstPageIndex, lastPageIndex)
  }, [currentPage, currentItems, countPerPage])

  const error = GlobalState.currentLocale.lang.includes('En')
    ? 'Sorry, nothing was found for your request'
    : GlobalState.currentLocale.lang.includes('ру')
    ? 'К сожалению, по вашему запросу ничего не найдено'
    : 'На жаль, за вашим запитом нічого не знайдено'

  const filter = () => {
    const { name, country, position, format } = VacanciesSearch.search
    let res: Array<Vacancy> = []
    if (name.length) {
      res = vacancies.list.filter((v: Vacancy) =>
        v.title.toLocaleLowerCase().includes(name),
      )
    } else res = vacancies.list

    if (country.length) {
      res = res.filter((v: Vacancy) => {
        if (country.trim() == v.location) {
          return v
        }
      })
    }

    if (position.length) {
      res = res.filter(
        (v: Vacancy) =>
          v.department.toLocaleLowerCase() == position.toLocaleLowerCase(),
      )
    }

    if (format.length) {
      res = res.filter(
        (v: Vacancy) =>
          v.format.toLocaleLowerCase() == format.toLocaleLowerCase(),
      )
    }

    setCurrentItems(res)
  }

  useEffect(() => {
    filter()
  }, [vacancies.list, VacanciesSearch.search])

  return (
    <>
      {currentTableData?.length ? (
        <table className="vacancies__table">
          {currentTableData?.length ? (
            <tr className="vacancies__table-tr">
              <td className="vacancies__table-td">
                {vacancies.vacancyPlaceholder}
              </td>
              <td className="vacancies__table-td">
                {vacancies.countryPlaceholder}
              </td>
              <td className="vacancies__table-td">
                {vacancies.formatPlaceholder}
              </td>
              <td></td>
            </tr>
          ) : (
            <></>
          )}
          {currentTableData?.map((v: any, i: number) => (
            <tr
              className="vacancies__table-tr"
              key={i}
              onClick={() => {
                window.open(v.link, '__blank')
              }}
            >
              <td className="vacancies__table-td">{v.title}</td>
              <td className="vacancies__table-td">{v.location}</td>
              <td className="vacancies__table-td">{v.format}</td>
              <td className="vacancies__table-td">
                {' '}
                <div className="vacancies__arrow-cont">
                  <div className="vacancies__arrow-right">
                    <ArrowRight />
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </table>
      ) : (
        <p className="vacancies__empty-res">
          {error} "{VacanciesSearch.search.name}"
        </p>
      )}

      <div className="vacancies__list">
        {currentTableData?.length ? (
          currentTableData?.map((v: any, i: number) => (
            <div
              className="vacancies__item"
              key={i}
              onClick={() => {
                window.open(v.link, '__blank')
              }}
            >
              <div className="vacancies__item-col">
                <div className="vacancies__item-title">{v.title}</div>
                <div className="vacancies__item-row">
                  <span className="vacancies__item-subtitle">{v.location}</span>
                  <span className="vacancies__item-subtitle">{v.format}</span>
                </div>
              </div>

              <div className="vacancies__arrow-cont">
                <div className="vacancies__arrow-right">
                  <ArrowRight />
                </div>
              </div>
            </div>
          ))
        ) : (
          <></>
        )}
      </div>

      <div
        className={classNames(
          'vacancies__bottom',
          countPerPage == vacancies.list.length ||
            (currentPage == lastPage && 'small'),
        )}
      >
        {currentItems?.length ? (
          <div className="vacancies__bottom-left">
            {countPerPage == vacancies.list.length ||
            currentPage == lastPage || !vacancies.list.length ? (
              <></>
            ) : (
              <div
                className="button black"
                onClick={() => {
                  setCount(vacancies.list.length)
                }}
              >
                {vacancies.showAll}
              </div>
            )}
            <Pagination
              itemsPerPage={Math.ceil(currentItems.length / countPerPage)}
              data={currentItems || []}
              currentPage={currentPage}
              setCurrentPage={(value) => setCurrentPage(value)}
              getLastPage={(value) => setLastPage(value)}
            />
          </div>
        ) : (
          <></>
        )}
        <div className="vacancies__bottom-right">
          <div className="vacancies__link">{vacancies.novacancies}</div>
          <div className="button white" onClick={changeCareerCoopState}>
            {vacancies.buttonText}
          </div>
        </div>
      </div>
    </>
  )
})

export default VacanciesList
